function UserPayrollPermission() {
  return <div>USER PAYROLL PERMISSION</div>;
}

export default UserPayrollPermission;
